import { getStoreFor } from 'Stores/StoreInstances'
import BaseStore from 'Stores/base_store/BaseStore'
import { action } from 'mobx'
import VirtualBankLineItems from 'DataServices/VirtualBankLineItems'

const STORE_TYPE = 'VirtualBankLineItems'

export function getVirtualBankLineItemsStoreFor (param, opts = {}) {
  return getStoreFor(VirtualBankLineItemsStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

export class VirtualBankLineItemsStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: true,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll () {
    let payload = {
      ...this.filter,
    }
    return VirtualBankLineItems.getAll(payload)
  }

  @action
  _fetchOne () {
    let payload = {
      ids: this._filter.id,
    }
    return VirtualBankLineItems.getAll(payload)
  }
}
